// Define the global Android interface
declare global {
    interface Window {
        Android?: {
            getMobileNumber: () => string;
            getDeviceId: () => string;
            onDataReceived: (data: string) => void;
        };
        AndroidNative?: {
            getMobileNumber: () => string;
        };
        AndroidAABridge?: {
            onConsentApproved: (consentHandle: string, consentId: string, fipIdsJson: string) => void;
        };
        AndroidInterface?: {
            onConsentEvent: (eventName: string, data: string) => void;
            post?: (event: string, data?: string) => void;
        };
    }
}

export const getAndroidUser = () => {
    let mobileNumber = "";
    let deviceId = "";

    try {
        if (window.Android) {
            mobileNumber = window.Android.getMobileNumber ? window.Android.getMobileNumber() : "";
            deviceId = window.Android.getDeviceId ? window.Android.getDeviceId() : "";
        }

        // Check for new AndroidNative bridge if mobile number still empty
        if (!mobileNumber && window.AndroidNative && window.AndroidNative.getMobileNumber) {
            mobileNumber = window.AndroidNative.getMobileNumber();
        }

        return { mobileNumber, deviceId };
    } catch (error) {
        console.error("Error fetching data from Android bridge:", error);
        return { mobileNumber: "", deviceId: "" };
    }
};

export const sendDataToAndroid = (data: any) => {
    let sent = false;
    if (window.Android && window.Android.onDataReceived) {
        try {
            window.Android.onDataReceived(JSON.stringify(data));
            console.log("Data sent to Android:", data);
            sent = true;
        } catch (error) {
            console.error("Error sending data to Android bridge:", error);
        }
    }

    if (window.AndroidInterface && window.AndroidInterface.onConsentEvent) {
        try {
            window.AndroidInterface.onConsentEvent(data.type || "consenpro:linkingComplete", JSON.stringify(data));
            console.log("Data sent to AndroidInterface:", data);
            sent = true;
        } catch (error) {
            console.error("Error sending data to AndroidInterface bridge:", error);
        }
    }

    if (!sent) {
        console.warn("Android bridge not available. Data:", data);
    }
};

export const notifyAndroidConsentApproved = (consentHandle: string, consentId: string, fipIds: string[]) => {
    if (window.AndroidAABridge && window.AndroidAABridge.onConsentApproved) {
        try {
            window.AndroidAABridge.onConsentApproved(consentHandle, consentId, JSON.stringify(fipIds));
            console.log("Consent Approved event sent to AndroidAABridge.");
        } catch (error) {
            console.error("Error triggering AndroidAABridge:", error);
        }
    } else {
        console.warn("AndroidAABridge not available... Fallback to Web-Only Mode.");
    }
};

export const notifySdkConsentError = (message: string = "User cancelled or linking failed") => {
    if (window.AndroidInterface) {
        try {
            window.AndroidInterface.onConsentEvent("error", "User cancelled or flow failed");
            console.log("Consent Error event sent to AndroidInterface.");
        } catch (error) {
            console.error("Error triggering AndroidInterface.onConsentEvent:", error);
        }
    } else {
        console.warn("AndroidInterface not available... fallback to Web-Only mode. Error:", message);
    }
};
